export default __webpack_public_path__ + "static/media/20.01e7aa78.png";